import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsCepech = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.saldo_cuota) }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.saldo_cuota) }, 0);
        props.setDebtFn(totalDebt);

        const periods = props.documents.map(d => d.periodo_cartera);
        const uniquePeriods = [...new Set(periods)];
        const isSamePeriod = uniquePeriods.length === 1;
        if(isSamePeriod){
            const period = uniquePeriods[0];
           console.log('periodo unico', period);
            //logica para determinar oferta segun periodo
            if(period === 2024){
                const condonarMap = {
                    1: 'Pagar 50%, Condonar 50%',
                    2: 'Pagar 1 cuota, condonar 1 cuota',
                    3: 'Pagar 1 cuota, condonar 2 cuotas',
                    4: 'Pagar 1 cuota, condonar 3 cuotas',
                    5: 'Pagar 2 cuotas, condonar 3 cuotas',
                    6: 'Pagar 2 cuotas, condonar 4 cuotas',
                    7: 'Pagar 2 cuotas, condonar 5 cuotas',
                    8: 'Pagar 2 cuotas, condonar 6 cuotas',
                    9:  'Pagar 3 cuotas, condonar 6 cuotas',
                    10: 'Pagar 3 cuotas, condonar 7 cuotas',
                    11: 'Pagar 3 cuotas, condonar 8 cuotas',
                    12: 'Pagar 3 cuotas, condonar 9 cuotas',
                    13: 'Pagar 3 cuotas, condonar 10 cuotas'
                };
                const offer = condonarMap[props.documents.length];
                if (offer) props.setOfferFn(offer);
            } else if(period === 2023){
                const asistencias = props.documents.map(d => d.rango_asistencia);
                const hasAsistencia = asistencias.some(a => a !== null);
                const isSameAsistencia = [...new Set(asistencias)].length === 1;
                if(hasAsistencia && isSameAsistencia){
                    const asistencia = asistencias[0].toUpperCase();
                    const isARange = asistencia.includes(' A ');
                    if(isARange){
                        const [min, max] = asistencia.split(' A ').map(a => parseInt(a));
                        //0 y 40
                        if(min >= 0 && max <= 40){
                            props.setOfferFn('Paga 1 cuota(valor capital) para anulación');
                        } else if(min >= 41 && max <= 80){
                            props.setOfferFn('Paga 2 cuotas(valor capital) para anulación');
                        } else if(min >= 81 && max <= 100){
                            props.setOfferFn('Paga 3 cuotas(valor capital) para anulación');
                        }
                    } else {
                        props.setOfferFn('Paga 1 cuota(valor capital) para anulación');
                    }
                }
            } else{
                props.setOfferFn('No disponible');
            }
        }


        

    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cedente</th>
                    <th className='center'>N Docto.</th>
                    <th className='right'>Estado Docto.</th>
                    <th className='right'>N. Cuota</th>
                    <th className='right'>Vencimiento</th>
                    <th className='center'>Saldo cuota</th>
                    <th className='center'>Período</th>
                    <th className='center'>Asistencia</th>
                    <th className='right'>Saldo Final</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.saldo_cuota} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    CEPECH 
                                </label>
                            </td>
                            <td className="center">{doc.nro_documento}</td>
                            <td className="right">{doc.estado_documento}</td>
                            <td className="right">{doc.nro_cuota}</td>
                            <td className="right">{Tools.fdCL(doc.fecha_vencimiento)}</td>
                            <td className="center">{Tools.fmtClAmmount(doc.saldo_cuota)}</td>
                            <td className="center">{doc.periodo_cartera}</td>
                            <td className="right">{doc.rango_asistencia??<span className='filler'/>}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_cuota)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsCepech;